import { ITheme } from 'application/utils/type'
export const theme: ITheme = {
  brand: 'Remserv',
  //media queries should match bootstrap media queries
  mq: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  colors: {
    primary: '#003d79',
    primaryButtonHover: '#2b74ae',
    buttonDisabled: '',
    secondary: '#066C87',
    textDarkblack: '#000',
    textLightblack: '#333',
    positive: '#3ba933',
    positive2: '#216039',
    positive3: '#247f38',
    primaryLightText: '#f7f7f7',
    secondaryLightText: '#999',
    spartaGreen: '#247F38',
    spartaGreen2: '#DBFBD9',
    secondaryHeading: '#066C87',
    borderColor: '#ccc',
    grey2: '#58595b',
    linkColor: '#333',
    yield: '#666',
    lightBackground: '#f7f7f7',
    white: '#fff',
    navColor: '#333',
    footerText: '#a2a2a2',
    alertGreen: '#247F38',
    alertGreen2: '#DBFBD9',
    alertGrey: '#939598',
    warning2: '#FFF8E9',
    warning: '#906A1D',
    warningContrast: '#654F0D',
    alertRed: '#721c24',
    shadowColour: '',
    cardHeaderFontColor: '#000',
    danger: '#c20000',
    boxShadow: '#f2f2f2',
    bannerSectionContentColor: '#000',
  },
  backgrounds: {
    backGround1: '#fff',
    backGround2: '#e6e6e6',
    backGround3: '#f7f7f7',
  },
  font: {
    weight: {
      normal: 500,
      slightBold: 600,
      semiBold: 800,
      bold: 900,
    },
    size: {
      smaller: '14px',
      small: '16px',
      medium: '18px',
      larger: '19px',
      largest: '36px',
    },
    caption: {
      fontSize: '18px',
    },
    primaryButton: {
      fontSize: '16px',
    },
    text: {
      fontSize: '18px',
    },
  },
  other: {
    primaryButton: {
      borderRadius: '0.25rem',
      fontWeight: 400,
      fontSize: '1rem',
    },
  },
}
